import React from 'react';
import { Alert, AlertObject } from '../Alert';

interface PropTypes {
  alert: AlertObject;
  setAlert: (alert: AlertObject | null) => void;
}

export function DefaultAlert(props: PropTypes) {
  if (!props.alert?.message) return null;

  return (
    <Alert
      type={props.alert.type}
      autoClearTimeout={4000}
      clearable={true}
      onClose={() => props.setAlert(null)}
    >
      {props.alert.message}
    </Alert>
  );
}
